module.exports = __webpack_public_path__ + "img/LIGASTAVOK.0a4883f6.svg";